export default __webpack_public_path__ + "static/media/backstrokes-1.222259a7.jpg";